'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _helpers = require('../helpers');

var _DFPAd = require('../../components/ads/dfp/DFPAd');

var _DFPAd2 = _interopRequireDefault(_DFPAd);

var _FWAd = require('../../components/ads/fw/Companion/FWAd');

var _FWAd2 = _interopRequireDefault(_FWAd);

var _FWAdStandAlone = require('../../components/ads/fw/StandAlone/FWAdStandAlone');

var _FWAdStandAlone2 = _interopRequireDefault(_FWAdStandAlone);

var _adSettings = require('./adSettings.json');

var _adSettings2 = _interopRequireDefault(_adSettings);

var _adTypes = require('./ad-types');

var AdTypes = _interopRequireWildcard(_adTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Ads utility
*/
var helper = {
  /**
   * Helper method to prepare ad props
   * @param {Object} settings from api
   * @returns {Object} ad settins
   */
  getSettings: function getSettings(settings) {
    /**
     * adSettings
     "sizes": [
     {
       "width": 300,
       "height": 250
     },
     {
       "width": 300,
       "height": 600
     },
     {
       "width": 160,
       "height": 600
     }
     ],
     "disableRefresh": true,
     "position": "MID",
     "lazyLoadSlotDisable": false
     */
    var devices = ['mobile', 'tablet', 'desktop'];
    var adSetting = {};
    var sizeMapping = {};
    var deviceSetting = '';

    if ((0, _helpers.exists)(settings)) {
      devices.map(function (device) {
        /* Building sizeMapping from
         desktop: {
         adType: "dfp",
         disableRefresh: true,
         lazyLoadSlotDisable: false,
         position: "MID",
         sizes: [
         {
         width: 728,
         height: 90
         },
         {
         width: 970,
         height: 90
         }
         ]
         }
         */
        deviceSetting = device + 'Settings';
        // If settings[deviceSetting] is null, exists helper method return true for the nested
        // property
        if (settings[deviceSetting] !== null) {
          if ((0, _helpers.exists)(settings[deviceSetting]) && (0, _helpers.exists)(settings[deviceSetting].sizes)) {
            // Matching ads sizeMapping format
            sizeMapping[device] = settings[deviceSetting].sizes.map(function (obj) {
              return [obj.width, obj.height];
            });
            if ((0, _helpers.exists)(settings[deviceSetting].position)) {
              adSetting.position = settings[deviceSetting].position;
            }
            if ((0, _helpers.exists)(settings[deviceSetting].refreshable)) {
              adSetting.refreshable = settings[deviceSetting].refreshable;
            }
          }
        }
        return device;
      });
      adSetting.sizeMapping = sizeMapping;
      adSetting.isSpecialAd = settings.isSpecialAd || false;
      adSetting.sequenceable = false;
      if (typeof settings.sequenceable === 'undefined') {
        adSetting.sequenceable = true;
      }
    }
    return adSetting;
  },
  getVideoSettings: function getVideoSettings(apiSettings) {
    if (apiSettings) {
      return apiSettings.map(function (setting) {
        return setting;
      }).join('&');
    }
    return '';
  },


  /**
   * Helper to build Ad video component by ad type
   * @param {string} type of ad
   * @returns {XML}
   */
  getVideoComp: function getVideoComp(type) {
    var adSettings = _adSettings2.default[AdTypes[type]];
    var FwSettings = this.getVideoSettings(adSettings);
    return _react2.default.createElement(_FWAd2.default, { adSetting: FwSettings });
  },


  /**
   * Helper to build Ad component by ad type
   * @param {string} type of ad
   * @param {boolean} isLazyLoaded the ad
   * @returns {Object}
   */
  getAd: function getAd(type) {
    var isLazyLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var adSettings = _adSettings2.default[AdTypes[type]];
    var settings = this.getSettings(adSettings);
    if ((0, _keys2.default)(settings).length) {
      var ad = _react2.default.createElement(_DFPAd2.default, settings);
      if (isLazyLoaded) {
        return _react2.default.createElement(
          _reactLazyload2.default,
          { height: 100, offset: 50, once: true },
          ad
        );
      }
      return ad;
    }
    return null;
  },


  /**
   * Helper to return stand alone sled ad only on mobile
   * on server side
   * @param {Object} pageData from api and context
   * @returns {XML}
   */
  getSledAd: function getSledAd(pageData) {
    if (pageData.device === 'mobile') {
      return _react2.default.createElement(_FWAdStandAlone2.default, { width: '1', height: '3', adType: 'SLED_AD', pageData: pageData });
    }
    return null;
  },

  /**
   * Helper to inject ad between widgets every 4 widgets
   * @param {Object} settings for ad insertion
   * @returns {array}
   */
  injectFullWidthAds: function injectFullWidthAds(settings) {
    var _this = this;

    var defaultOptions = {
      widgets: [], // widget list
      startFrom: 1, // position to start injecting ads
      injectEvery: 4, // ads interval
      numberOfAds: 10, // number of ads to insert
      type: 'MID_AD', // ad type
      lazyload: true // enable / disable lazy load
    };

    var _Object$assign = (0, _assign2.default)(defaultOptions, settings),
        widgets = _Object$assign.widgets,
        startFrom = _Object$assign.startFrom,
        injectEvery = _Object$assign.injectEvery,
        numberOfAds = _Object$assign.numberOfAds,
        type = _Object$assign.type,
        lazyload = _Object$assign.lazyload;

    var insertedAds = 0;
    if (Array.isArray(widgets) && widgets.length) {
      var readyWidgetList = [];
      widgets.forEach(function (w, i) {
        if (insertedAds < numberOfAds && (numberOfAds === 1 || i + 1 > startFrom && !((i + 1 - (startFrom - 1)) % injectEvery))) {
          insertedAds += 1;
          readyWidgetList.push(w);
          readyWidgetList.push(_react2.default.createElement(
            'div',
            { className: 'uvs-ad-full-width' },
            _this.getAd(type, lazyload)
          ));
        } else {
          readyWidgetList.push(w);
        }
      });
      return readyWidgetList;
    }
    return widgets;
  }
};

exports.default = helper;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/adHelper.js
// module id = 158
// module chunks = 35783957827783